// extracted by mini-css-extract-plugin
export default {"sky":"SkyBackground_sky__cwX1o","still":"SkyBackground_still__RbmQM","scene":"SkyBackground_scene__13rdl"};